import { DatePipe, ViewportScroller } from '@angular/common';
import { Component, ElementRef, Input, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { MessageService } from 'primeng/api';
import { Table } from 'primeng/table';
import { ExportExcelService } from '../../../shared/excel-service/export-excel.service';
import { OperacoesBloqueadasService } from './operacoes-bloqueadas.service';
import { FiltroDealers } from './filtro-dealer';

@Component({
  selector: 'app-operacoes-bloqueadas',
  templateUrl: './operacoes-bloqueadas.component.html',
  styleUrls: ['./operacoes-bloqueadas.component.scss']
})
export class OperacoesBloqueadasComponent implements OnInit {
  @Input() filtros: any;

  form: FormGroup;

  registros: any[] = [];
  registrosAnalitico: any[] = [];

  columnsSynthetic: any[];
  _selectedColumnsSynthetic: any[];

  columnsAnalytical: any[];
  _selectedColumnsAnalytical: any[];

  dataInicial: Date;
  dataFinal: Date;
  nomeModulo: string;
  nomeModuloAnalitico: string;

  first: number = 0;
  displayRows: number = 0;
  rows: number = 10;
  totalRecords: number = 0;

  firstAn: number = 0;
  displayRowsAn: number = 0;
  rowsAn: number = 10;
  totalRecors: number = 0;

  maxDate: Date = new Date();

  filtrosDealers: FiltroDealers;

  displayFiltrosDealers: boolean = false;
  displayMensagem: boolean = false;
  displayDadoEnviado: boolean = false;
  carregando: boolean = false;
  loading: boolean = false;
  filtrado: boolean = false;
  
  // Dealer selecionado para exibir no título do detalhamento
  dealerCodeSelecionado: string = "";
  dealerNameSelecionado: string = "";
  
  // Conteúdo das modais
  conteudoMensagem: string = "";
  conteudoDadoEnviado: string = "";

  @ViewChild('dt') dt: Table;
  @ViewChildren('dealers') dealers: QueryList<ElementRef>;

  constructor(
    private service: OperacoesBloqueadasService,
    private translate: TranslateService,
    private exportExcelService: ExportExcelService,
    private messageService: MessageService,
    private fb: FormBuilder,
    private date: DatePipe,
    private viewportScroller: ViewportScroller,
  ) {
    this.filtros = {};
    this.nomeModulo = 'Operações Bloqueadas - Sintético';
    this.nomeModuloAnalitico = 'Operações Bloqueadas - Analítico';
    this.filtrosDealers = new FiltroDealers(this.service);
    this.tratarData();

    this.form = this.fb.group({
      data_inicial: [moment(this.dataInicial).format('DD-MM-YYYY')],
      data_final: [moment(this.dataFinal).format('DD-MM-YYYY')],
      dealer: [''],
      codigo: ['']
    });

    this.maxDate.setDate(this.maxDate.getDate());
  }

  ngOnInit() {
    // Grid Principal
    this.columnsSynthetic = [
      { field: 'dealerCode', header: 'Cod. Dealer' },
      { field: 'dealerName', header: 'Nome Dealer' },
      { field: 'quantidadeBloqueados', header: 'Qtd. Bloqueados' },
    ];

    // Grid de Detalhe
    this.columnsAnalytical = [
      { field: 'operacao', header: 'Operação' },
      { field: 'registro', header: 'Registro' },
      { field: 'mensagem', header: 'Mensagem', width: '280px' },
      { field: 'dadoEnviado', header: 'Dado Enviado', width: '280px' },
      { field: 'dataUltimaAtualizacao', header: 'Data' },
      { field: 'acao', header: 'Ação', width: '140px' },
    ];

    this._selectedColumnsSynthetic = this.columnsSynthetic;
    this._selectedColumnsAnalytical = this.columnsAnalytical;

    this.filtrosDealers.carregar();
    this.getAll();
  }

  @Input() get selectedColumnsSynthetic(): any[] {
    return this._selectedColumnsSynthetic;
  }

  @Input() get selectedColumnsAnalytical(): any[] {
    return this._selectedColumnsAnalytical;
  }

  set selectedColumnsSynthetic(val: any[]) {
    this._selectedColumnsSynthetic = this.columnsSynthetic.filter(col => val.includes(col));
  }

  set selectedColumnsAnalytical(val: any[]) {
    this._selectedColumnsAnalytical = this.columnsAnalytical.filter(col => val.includes(col));
  }

  get f() { return this.form.controls; }

  private getAll() {
    this.loading = true;

    this.service.getDados(this.f.data_inicial.value, this.f.data_final.value, this.f.dealer.value).subscribe(
      res => {
        this.registros = res;

        this.loading = false;
        this.carregando = false;
      },
      error => {
        console.error('Erro ao carregar dados:', error);
        this.registros = [];
        this.loading = false;
        this.carregando = false;
        this.messageService.add({
          key: 'businessIntelligenceDetalhado',
          severity: 'error',
          summary: 'Erro',
          detail: 'Erro ao carregar operações bloqueadas'
        });
      }
    );
  }

  private getAllAnalitico() {
    this.loading = true;

    this.service.getDadosAnaliticos(this.f.codigo.value, this.f.data_inicial.value, this.f.data_final.value).subscribe(
      res => {
        // Atualiza informações do dealer no título (do primeiro item)
        if (res.length > 0) {
          this.dealerCodeSelecionado = res[0].codDealers || '';
          this.dealerNameSelecionado = res[0].nomeDealer || '';
        }
        
        // Mapeia os dados do formato da API para o formato do componente
        this.registrosAnalitico = res.map(item => ({
          id: item.id,
          reenviar: item.reenviar,
          operacao: item.operacao,
          registro: item.registro,
          mensagem: item.mensagem,
          dadoEnviado: item.dadosEnviado,
          dataUltimaAtualizacao: item.dataUltimaAtualizacao
        }));

        this.loading = false;
      },
      error => {
        console.error('Erro ao carregar dados analíticos:', error);
        this.registrosAnalitico = [];
        this.loading = false;
        this.messageService.add({
          key: 'businessIntelligenceDetalhado',
          severity: 'error',
          summary: 'Erro',
          detail: 'Erro ao carregar detalhes das operações bloqueadas'
        });
      }
    );

    if (!this.filtrado) {
      setTimeout(() => { this.viewportScroller.scrollToAnchor('target'); }, 300);
    }
  }

  public selecionarDealer() {
    this.displayFiltrosDealers = true;
  }

  public abrirMensagem(index: number) {
    this.conteudoMensagem = this.registrosAnalitico[index].mensagem;
    this.displayMensagem = true;
  }

  public fecharMensagem() {
    this.displayMensagem = false;
    this.conteudoMensagem = "";
  }

  public abrirDadoEnviado(index: number) {
    this.conteudoDadoEnviado = this.registrosAnalitico[index].dadoEnviado;
    this.displayDadoEnviado = true;
  }

  public fecharDadoEnviado() {
    this.displayDadoEnviado = false;
    this.conteudoDadoEnviado = "";
  }

  public reenviar(row: any) {
    if (!row || !row.id || row.reenviar === 'S' || row.reenviando) {
      return;
    }

    row.reenviando = true;
    this.service.reenviar(row.id).subscribe(
      () => {
        row.reenviar = 'S';
        row.reenviando = false;
        this.messageService.add({
          key: 'businessIntelligenceDetalhado',
          severity: 'success',
          summary: 'Reenvio solicitado',
          detail: 'O registro será reenviado no próximo ciclo do SrvNBSPortal.'
        });
      },
      error => {
        row.reenviando = false;
        console.error('Erro ao solicitar reenvio:', error);
        this.messageService.add({
          key: 'businessIntelligenceDetalhado',
          severity: 'error',
          summary: 'Erro',
          detail: 'Não foi possível solicitar o reenvio'
        });
      }
    );
  }

  public copiarParaClipboard(texto: string) {
    // Cria um elemento textarea temporário
    const textArea = document.createElement('textarea');
    textArea.value = texto;
    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    textArea.style.top = '-999999px';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    
    try {
      // Executa o comando de copiar
      document.execCommand('copy');
      this.messageService.add({
        key: 'businessIntelligenceDetalhado',
        severity: 'success',
        summary: 'Sucesso',
        detail: 'Conteúdo copiado para a área de transferência!'
      });
    } catch (err) {
      this.messageService.add({
        key: 'businessIntelligenceDetalhado',
        severity: 'error',
        summary: 'Erro',
        detail: 'Falha ao copiar conteúdo'
      });
    } finally {
      document.body.removeChild(textArea);
    }
  }

  protected removerDealer(dealer: any) {
    dealer.selecionado = false;
    const index = this.filtros.dealers;
    if (index > -1) {
      this.filtros.dealers.splice(index, dealer);
      this.filtrosSelecionados();
    }
  }

  public onAdicionarDealerFiltro(dealer: any) {
    dealer.selecionado = true;
    const sel = [];

    this.incluirFiltroDealers(sel);
    this.filtros.dealers = sel;
  }

  private incluirFiltroDealers(filtros: any[]) {
    if (this.filtrosDealers.selecionados().length > 0) {
      const item = { 'chave': 'dealers', 'valor': [] };
      this.filtrosDealers.selecionados().forEach(element => {
        item.valor.push(element.id);
      });
      filtros.push(item);
    }
  }

  private tratarData() {
    const dataInicio = new Date();
    const dataFim = new Date();

    let firstDay = new Date(dataInicio.getFullYear(), dataInicio.getMonth(), 1);

    this.dataInicial = firstDay;
    this.dataFinal = dataFim;
  }

  public filtroAPI() {
    this.carregando = true;
    this.filtrado = true;

    this.f.data_inicial.setValue(moment(this.dataInicial).format('DD-MM-YYYY'));
    this.f.data_final.setValue(moment(this.dataFinal).format('DD-MM-YYYY'));

    this.filtrosSelecionados();
    this.getAll();

    if (this.registrosAnalitico.length != 0) {
      this.getAllAnalitico();
    }
  }

  private filtrosSelecionados() {
    const dealers = [];

    this.incluirFiltroDealers(dealers);

    this.filtros.dealers = dealers.map(r => r.valor);

    if (this.filtros.dealers.length != 0) {
      this.f.dealer.setValue(this.filtros.dealers[0]);
      this.registrosAnalitico.length = 0;
    } else {
      this.f.dealer.setValue('');
    }
  }

  public limpaDataInicial() {
    const dataInicio = new Date();
    this.dataInicial = new Date(dataInicio.getUTCFullYear(), dataInicio.getMonth(), 1);
  }

  public limpaDataFinal() {
    const dataFim = new Date();
    this.dataFinal = new Date(dataFim.getFullYear(), dataFim.getMonth(), dataFim.getDate());
  }

  public limparFiltros() {
    this.tratarData();

    if (this.filtros.dealers != undefined) {
      this.filtros.dealers.length = 0;
    }

    this.dealers.forEach(item => {
      let el: HTMLElement = item.nativeElement;
      el.click();
    });

    this.f.dealer.setValue('');
    this.f.codigo.setValue('');

    this.getAll();
    this.registrosAnalitico.length = 0;
  }

  public exportExcel() {
    let registros = [];
    let registrosAnalitico = [];

    this.service.getDados(this.f.data_inicial.value, this.f.data_final.value, this.f.dealer.value).subscribe(res => {
      registros = res;

      if (registros.length > 0) {
        this.exportExcelService.nomeModulo = this.nomeModulo;
        this.exportExcelService.ExportTOExcelJSON(registros.map(r => {
          let linha = {};

          this._selectedColumnsSynthetic.forEach(c => {
            linha[this.translateHeader(c.header)] = this.translateField(r[c.field]);
          });

          return linha;
        }));
      } else {
        this.messageService.add({ key: 'businessIntelligenceDetalhado', severity: 'warn', summary: this.translate.instant('businessIntelligence.tol.alerta'), detail: this.translate.instant('businessIntelligence.tol.alertaExportacao') });
      }
    });

    this.service.getDadosAnaliticos(this.f.codigo.value, this.f.data_inicial.value, this.f.data_final.value).subscribe(res => {
      // Mapeia os dados do formato da API para o formato do componente
      registrosAnalitico = res.map(item => ({
        operacao: item.operacao,
        registro: item.registro,
        mensagem: item.mensagem,
        dadoEnviado: item.dadosEnviado,
        dataUltimaAtualizacao: item.dataUltimaAtualizacao
      }));

      if (registrosAnalitico.length > 0) {
        this.exportExcelService.nomeModulo = this.nomeModuloAnalitico;
        this.exportExcelService.ExportTOExcelJSON(registrosAnalitico.map(r => {
          let linha = {};

          this._selectedColumnsAnalytical.filter(c => c.field !== 'acao').forEach(c => {
            linha[this.translateHeader(c.header)] = this.translateField(r[c.field]);
          });

          return linha;
        }));
      } else {
        this.messageService.add({ key: 'businessIntelligenceDetalhado', severity: 'warn', summary: this.translate.instant('businessIntelligence.tol.alerta'), detail: this.translate.instant('businessIntelligence.tol.alertaExportacao') });
      }
    });
  }

  protected translateHeader(item) {
    return item;
  }

  protected translateField(item) {
    return item;
  }

  public getDealerCode(index) {
    this.filtrado = false;
    this.f.codigo.setValue(this.registros[index].dealerCode);
    
    // Armazena informações do dealer selecionado para exibir no título
    this.dealerCodeSelecionado = this.registros[index].dealerCode;
    this.dealerNameSelecionado = this.registros[index].dealerName;
    
    if (this.registros[index].quantidadeBloqueados != 0) {
      this.getAllAnalitico();
    } else {
      this.registrosAnalitico.length = 0;
    }
  }

  /**
   * Função de ordenação customizada para tratar corretamente a coluna de data
   * Formato esperado: DD/MM/YYYY HH:mm:ss
   */
  public customSort(event: any) {
    event.data.sort((data1, data2) => {
      let value1 = data1[event.field];
      let value2 = data2[event.field];
      let result = null;

      // Tratamento especial para a coluna de data
      if (event.field === 'dataUltimaAtualizacao') {
        const date1 = this.parseDataBrasileira(value1);
        const date2 = this.parseDataBrasileira(value2);
        
        if (date1 === null && date2 === null) {
          result = 0;
        } else if (date1 === null) {
          result = -1;
        } else if (date2 === null) {
          result = 1;
        } else {
          result = date1.getTime() - date2.getTime();
        }
      } else {
        // Ordenação padrão para outras colunas
        if (value1 == null && value2 != null) {
          result = -1;
        } else if (value1 != null && value2 == null) {
          result = 1;
        } else if (value1 == null && value2 == null) {
          result = 0;
        } else if (typeof value1 === 'string' && typeof value2 === 'string') {
          result = value1.localeCompare(value2);
        } else {
          result = (value1 < value2) ? -1 : (value1 > value2) ? 1 : 0;
        }
      }

      return (event.order * result);
    });
  }

  /**
   * Converte string de data no formato brasileiro (DD/MM/YYYY HH:mm:ss) para objeto Date
   * @param dataString - String no formato DD/MM/YYYY HH:mm:ss
   * @returns Date object ou null se inválido
   */
  private parseDataBrasileira(dataString: string): Date | null {
    if (!dataString) {
      return null;
    }

    try {
      // Formato: DD/MM/YYYY HH:mm:ss
      const partes = dataString.split(' ');
      const data = partes[0].split('/');
      const hora = partes.length > 1 ? partes[1].split(':') : ['0', '0', '0'];

      const dia = parseInt(data[0], 10);
      const mes = parseInt(data[1], 10) - 1; // Mês começa em 0 no JavaScript
      const ano = parseInt(data[2], 10);
      const horas = parseInt(hora[0], 10);
      const minutos = parseInt(hora[1], 10);
      const segundos = parseInt(hora[2], 10);

      const dateObj = new Date(ano, mes, dia, horas, minutos, segundos);

      // Verifica se a data é válida
      if (isNaN(dateObj.getTime())) {
        return null;
      }

      return dateObj;
    } catch (error) {
      return null;
    }
  }

}
